// src/components/commun/FormLayout.jsx
import React from 'react';
import { Box, Paper, Container, Slide, Typography } from '@mui/material';
import Header from '../header/header';
import './FormLayout.css';

const FormLayout = ({ children, infoTitle, infoSubtitle, infoPoints }) => (
  <>
    <Header />
    <Box className="layout-wrapper">
      <Box className="info-section-layout">
        <Box className="info-content">
          <Typography variant="h5" className="info-title">
            {infoTitle}
          </Typography>

          {infoSubtitle && (
            <Typography variant="body1" className="info-subtitle">
              {infoSubtitle}
            </Typography>
          )}

          <ul className="info-points">
            {infoPoints.map((point, idx) => (
              <li key={idx}>{point}</li>
            ))}
          </ul>
        </Box>
      </Box>

      <Box className="form-section">
        <Container maxWidth="sm">
          <Slide in direction="up" timeout={500}>
            <Paper className="form-paper" elevation={6}>
              {children}
            </Paper>
          </Slide>
        </Container>
      </Box>
    </Box>
  </>
);


export default FormLayout;
